import React from "react";
import PropTypes from "prop-types";

import {
  BaseOptimizationIcon,
  BaseScenarioIcon,
  DraftScenarioIcon,
  SimulationIcon,
  SimulationReducedScopeIcon,
  UnconstainedScenarioIcon,
  ValidatedScenarioIcon,
} from "../../theme/AthenaIcons";
import Scenario from "../../api/Scenario";
import { withStyles } from "@material-ui/core/styles";

const styles = (theme) => ({
  icon: {
    display: "block",
  },
});

@withStyles(styles)
class ScenarioTypeIcon extends React.Component {
  static propTypes = {
    scenario: PropTypes.instanceOf(Scenario).isRequired,
  };

  render() {
    const { scenario, classes } = this.props;
    if (scenario.isBase) {
      return <BaseScenarioIcon className={classes.icon} />;
    }
    if (scenario.isValidated) {
      return <ValidatedScenarioIcon className={classes.icon} />;
    }
    if (scenario.isDraft) {
      return <DraftScenarioIcon className={classes.icon} />;
    }
    if (scenario.isUnconstrainedCapacity) {
      return <UnconstainedScenarioIcon className={classes.icon} />;
    }
    if (scenario.isBaseOptimization) {
      return <BaseOptimizationIcon className={classes.icon} />;
    }
    if (scenario.isReducedScopeSimulation) {
      return <SimulationReducedScopeIcon className={classes.icon} />;
    }
    return <SimulationIcon className={classes.icon} />;
  }
}

export default ScenarioTypeIcon;
